import $api from "../http";

export default class FileService {
    static async getUserFiles(userId) {
        return $api.get(`file/user/${userId}`, {})
    }

    static async uploadFile(userId, file) {
        const formData = new FormData();
        formData.append('file', file); // 'file' — имя поля, с которым сервер ожидает файл

        return $api.post(`file/upload/${userId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static async readFile(type, args) {
        return $api.post(`file/read-file`, {type, args})
    }

    static async deleteFile(userId, id) {
        return $api.delete(`file/${userId}/${id}`)
    }
}